import React from "react";
import * as supplierService from "../../services/supplierService";
import { MessagesPage } from "../Proc/Chat";

// Supplier: every conversation with a buyer.
const loadBuyers = async () => {
  const res = await supplierService.getBuyers();
  return (res?.data || []).filter((b) => b.status === "ACTIVE").map((b) => ({ label: b.buyer_name, ref: { buyer_id: b.buyer_id } }));
};

export default function SupplierMessages() {
  return <MessagesPage service={supplierService} side="SUPPLIER" loadParties={loadBuyers} />;
}
